import { z } from 'zod';

export const ProductDetailManufacturerDTO = z
    .object({
        name: z.string().optional(),
        address: z.string().optional(),
        email: z.string().optional(),
        contact: z
            .object({
                name: z.string().optional(),
                address: z.string().optional(),
                email: z.string().optional(),
            })
            .optional(),
    })
    .optional();
